import { useLocation, useOutlet } from 'react-router-dom';
import styles from './PageTransition.module.scss';

/**
 * @description Wraps the current route element with a subtle fade-in so pages don't "pop" in.
 * Intended to be used inside layouts (e.g. AuthLayout/MainLayout) instead of per-page usage.
 *
 * ZLAYT-1443 (QA D-10): this used to hold the next page back until the
 * previous page's exit animation had finished. A hidden, minimised or covered
 * tab, or one driven by an automation agent, gets no animation frames, so the
 * exit never finished there: the documents list stayed on screen under a
 * report URL, and one report stayed on screen under another's URL, for as
 * long as the tab went without frames. The page for the current URL is now
 * mounted at once and only fades in, with CSS.
 */
function PageTransition() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <div key={location.pathname} className={styles.page}>
      {outlet}
    </div>
  );
}

export default PageTransition;
